import PropTypes from 'prop-types'
import { useState } from 'react'
import { TabContainer } from 'react-bootstrap'

import Content from './components/Content'
import Navigation from './components/Navigation'

const DEFAULT_ACTIVE_KEY = 'details'

const Desktop = ({ isPrint, kind }) => {
  const [eventKey, setEventKey] = useState(DEFAULT_ACTIVE_KEY)

  return (
    <div className='pdp-tabs'>
      <TabContainer
        defaultActiveKey={DEFAULT_ACTIVE_KEY}
        id='product-details-tab-container'
      >
        <Navigation isPrint={isPrint} kind={kind} setEventKey={setEventKey} />
        <Content eventKey={eventKey} />
      </TabContainer>
    </div>
  )
}

Desktop.propTypes = {
  isPrint: PropTypes.bool.isRequired,
  kind: PropTypes.string
}

export default Desktop
